export default {
    apiUrl    : 'https://api.futureproof.app',
    apiPrefix : '/',
    amplitudeApiKey: '34f45b64314c43004a565be08cc7a060',
    environment: 'production'
};
